import React from 'react';

const Contact = () => {
  return (
    <div className="page-content">
      <div className="page-header">
        <h1>Contact</h1>
      </div>
      <div className="page-text">
        <div className="contact-info">
          <h3>Get in Touch</h3>
          <p>For inquiries or to explore partnership opportunities, reach us at:</p>
          
          <div className="contact-methods">
            <div className="contact-item">
              <strong>Email:</strong>
              <a href="mailto:hello@deadair.ai">hello@deadair.ai</a>
            </div>
          </div>
          
          <div className="contact-note">
            <p>Inquire discreetly. Influence begins here.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;